import SET_LOCALE from './types';
export default {
  [SET_LOCALE](state, payload) {
    const currentState = state;
    currentState.currentLocale = payload;
  }

};